import { Container, ContainerGutter, Richtext } from '@volkswagen-onehub/components-core';
import React from 'react';
import { DisclaimerTextLegal } from '../../../shared/ui/disclaimer-text-legal';

interface DisclaimerContentProps {
	fontSize?: string;
	showDisclaimerNumber?: boolean;
	textGutter?: ContainerGutter;
}

export const BonoDisclaimerText =
	'Promoción únicamente válida para el propietario/a de un vehículo de la marca Volkswagen Turismos que tenga una orden de reparación en curso entre el periodo comprendido entre el 01/09/2026 y el 31/10/2026 (ambos incluidos) y se registrara debidamente como miembro del Club VW durante su paso por taller, con fechas igual o posterior a la fecha de apertura de la orden de reparación.<br /><br />La promoción consiste en un Bono de 50€ (IVA incluido) en recambios originales (sobre PVP Recomendado), el cual se podrá redimir en los próximos 12 meses para cualquier tipo de operación, siempre y cuando se trate de un ticket mínimo de 100€ en recambios. Mano de Obra no incluida.<br /><br />Esta promoción es personal e intransferible, no se puede acumular con otras promociones y es válida en cualquier Servicio Oficial de la marca Volkswagen en península y baleares. Para más información consulta con tu Servicio Oficial las características específicas de la presente promoción, así como otras prestaciones y/o descuentos que pueda ofrecerte.';

export const BonoPosventaDisclaimerContent = ({
	fontSize,
	showDisclaimerNumber = true,
	textGutter = ContainerGutter.static350,
}: DisclaimerContentProps): React.JSX.Element => {
	return (
		<Container wrap={'always'} gutter={textGutter}>
			<DisclaimerTextLegal fontSize={fontSize}>
				{showDisclaimerNumber && '1. '}
				<Richtext dangerouslyParseRawHTML markdown={BonoDisclaimerText} />
			</DisclaimerTextLegal>
		</Container>
	);
};
